import React, { useState } from 'react';
import { Box, Icon, InputField, RadioButton } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../shared/hooks';
import { TEMPLATES_TYPES } from '../../data-layer/violationsReportConstants';

interface TemplatesProps {
  onReportSelect?: (reportValue: string) => void;
  selectedReport?: string;
}

/**
 * Templates
 */
function Templates({
  onReportSelect,
  selectedReport: propSelectedReport,
}: TemplatesProps) {
  const l = useInvertedLocalize();
  const [searchValue, setSearchValue] = useState('');

  // Use the selectedReport from props (synchronized from parent)
  const currentSelectedReport = propSelectedReport ?? 'summary';

  const handleClick = (e: object, value: string) => {
    onReportSelect?.(value);
  };

  const filteredReports = TEMPLATES_TYPES.filter(
    (report) =>
      l(report.title).toLowerCase().includes(searchValue.toLowerCase()) ||
      l(report.description).toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <Box className='ReportModal-templates'>
      <InputField
        name='basic'
        placeholder='Search'
        kind='search'
        backgroundColor='neutral'
        prefixIcon={
          <Icon kind='Search' color='--color-foreground-neutral-subtle' />
        }
        value={searchValue}
        setValue={setSearchValue}
      />
      {filteredReports.map((report) => (
        <RadioButton
          key={report.id}
          id={report.id}
          name={report.name}
          title={l(report.title)}
          description={l(report.description)}
          value={report.value}
          radioSelection={currentSelectedReport}
          onClick={handleClick}
        />
      ))}
    </Box>
  );
}

Templates.defaultProps = {
  onReportSelect: undefined,
  selectedReport: undefined,
};

export default Templates;
